import { useTranslation } from 'utils/i18n';

interface Props {
  isValid?: boolean;
  showBackBtn?: boolean;
  submitBtnText?: string;
  backBtnText?: string;
  handleBackBtnClick?: () => void;
  handleCancelBtnClick?: () => void;
  showCancelBtn?: boolean;
  cancelBtnText?: string;
}

const InstructionalFormActions = ({
  isValid = false,
  showBackBtn = true,
  submitBtnText,
  backBtnText,
  handleBackBtnClick = () => {},
  handleCancelBtnClick = () => {},
  showCancelBtn = false,
  cancelBtnText,
}: Props) => {
  const { t } = useTranslation('common');
  return (
    <p className="instructional-form__actions">
      <input
        className="button button--secondary button--block"
        type="submit"
        disabled={!isValid}
        value={submitBtnText || t('continue')}
        data-cy="continueButton"
        data-testid="instructionalFormSubmitButton"
      />
      {showBackBtn && (
        <button
          onClick={handleBackBtnClick}
          className="button button--text"
          data-testid="goBack"
        >
          {backBtnText || t('go_back')}
        </button>
      )}
      {showCancelBtn && (
        <button
          onClick={handleCancelBtnClick}
          className="button button--text"
          data-testid="cancel"
        >
          {cancelBtnText || t('cancel')}
        </button>
      )}
    </p>
  );
};

export default InstructionalFormActions;
